export const INCORRECT_NUMBER = 'analytics/INCORRECT_NUMBER';
export const CHANGE_SETTLED_BETS_TAB = 'analytics/CHANGE_SETTLED_BETS_TAB';
export const SETTLED_BET_DETAILS = 'analytics/SETTLED_BET_DETAILS';
export const GO_TO_ANONYMOUS_LOGIN = 'analytics/GO_TO_ANONYMOUS_LOGIN';
export const OPEN_ONLINE_LINK_MODAL = 'analytics/OPEN_ONLINE_LINK_MODAL';
export const OPEN_SPORTS_PAGE = 'analytics/OPEN_SPORTS_PAGE';
export const LINK = 'analytics/LINK';
export const LOGOUT = 'analytics/LOGOUT';
export const LOCATION_CHANGE = 'analytics/LOCATION_CHANGE';
export const SET_CURRENT_BET = 'analytics/SET_CURRENT_BET';

export const goToAnonymousLogin = () => ({
  type: GO_TO_ANONYMOUS_LOGIN
});

export const incorrectNumber = () => ({
  type: INCORRECT_NUMBER
});

export const changeSettledBetsTab = (tab) => ({
  type: CHANGE_SETTLED_BETS_TAB,
  tab
});

export const settledBetDetails = ({ betPlacedTime, betStake, betType, selectionLabel }) => ({
  type: SETTLED_BET_DETAILS,
  betPlacedTime,
  betStake,
  betType,
  selectionLabel
});

export const setCurrentBet = ({ betPlacedTime, betStake, betType, selectionLabel }) => ({
  type: SET_CURRENT_BET,
  betPlacedTime,
  betStake,
  betType,
  selectionLabel
});

export const openOnlineLinkModal = (submissionType) => ({
  type: OPEN_ONLINE_LINK_MODAL,
  submissionType
});

export const openSportsPage = () => ({
  type: OPEN_SPORTS_PAGE
});

export const link = ({ source, path, name }) => ({
  type: LINK,
  source,
  path,
  name
});

export const logOut = ({ source, name }) => ({
  type: LOGOUT,
  source,
  name
});

export const locationChange = ({ previousPath, currentPath }) => ({
  type: LOCATION_CHANGE,
  previousPath,
  currentPath
});
